import { Injectable } from '@angular/core';
import { Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WebService } from '../web.service';
import { RadicationSS } from '../../class/radicationSS';

@Injectable()
export class RadicationSSService extends WebService {

    public getRadicationSS (page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (page !== null && page !== undefined) {
            params.append('_page', String(page));
        } else {
            params.append('_page', '1');
        }

        if (per_page !== null && per_page !== undefined) {
            params.append('_limit', String(per_page));
        } else {
            params.append('_limit', '10');
        }

        if (sort !== null && sort !== undefined) {
            params.append('_sort', String(sort));
        }

        if (query !== null && query !== undefined && query !== '') {
            params.append('_q', String(query));
        }

        if (filters !== null && filters !== undefined && filters.length > 0) {
            filters.forEach(element => {
                params.append(element.key, String(element.value));
            });
        }

        params.append('_with', String('company,department,venue,created_by,candidate,updated_by'));

        const options = new RequestOptions({search: params, headers: this.headers});
        

        return this.http.get( `${this.apiUrl}/radication-ss?${params}`, options);
    }

    public newRadicationSS(body: Object): Observable<Response> {
        return this.http.post( `${this.apiUrl}/radication-ss`, JSON.stringify(body) , { headers: this.headers } );
    }

    public updateRadicationSS(id: number, body: Object): Observable<Response> {
        return this.http.patch( `${this.apiUrl}/radication-ss/${id}`, JSON.stringify(body) , { headers: this.headers } );
    }

    public deleteRadicationSS(id: number): Observable<Response> {
        return this.http.delete( `${this.apiUrl}/radication-ss/${id}`, { headers: this.headers } );
    }

    public infoRadicationSS(id: number): Observable<Response> {
        return this.http.get( `${this.apiUrl}/radication-ss?id=${id}`,  { headers: this.headers } );
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/radicationSS/radicationSS.service.ts